import React, { useEffect,useState } from 'react';
import styled from 'styled-components';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { makeGetRequest } from '../services/httpHelper';
import ErrorHandler from '../services/ErrorHandler';
import { toTitleCase } from '../utils/myFunctions';
import { IMAGE_BASE_URL } from '../constants/paths';

const Section = styled.section`
  padding: 80px 20px;
  background-color: #ffffff;
`;

const Heading = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 50px;
  color: #119687;
`;

const StyledCard = styled(Card)`
  border: none;
  text-align: center;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 16px rgba(0,0,0,0.05);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  img {
    width: 120px;
    height: 120px;
    object-fit: cover;
    margin: 0 auto 15px;
    border-radius: 50%;
    border: 4px solid #119687;
  }

  h5 {
    font-size: 1.2rem;
    font-weight: 700;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  p {
    margin: 0;
    font-size: 0.95rem;
    color: #666;
  }
`;

const LeadershipSection = () => {

    const [leaders,setLeaders] =useState(null)
    const [isLoading,setIsLoading] = useState(true)
    const [serverError,setServerError] = useState(null)

  const church = JSON.parse(localStorage.getItem('church')) || {};

  const leadersx = church.leaders || [
    {
      name: "Rev. John Doe",
      title: "Senior Pastor",
      photo: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      name: "Pastor Jane Smith",
      title: "Associate Pastor",
      photo: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      name: "Elder Mark Njenga",
      title: "Elder",
      photo: "https://randomuser.me/api/portraits/men/65.jpg",
    },
  ];

  useEffect(()=>{
 const getChurchLeaders = async()=>{
        setIsLoading(true)
        const res = await makeGetRequest('list-church-leaders/'+church.id)
        if(res && res.errorType){
            setIsLoading(false)
            const errorMessage = ErrorHandler(res)
            setServerError(errorMessage)
            
        }else{
            setServerError(null)
            setLeaders(res.data);
            setIsLoading(false);
        }

    }
    getChurchLeaders();

  },[])

  if(!leaders){
    return
  }
  

  return (
    <Section id="leadership">
      <Container>
        <Heading>{church.leadership_section_title || "Meet Our Leaders"}</Heading>
        <Row>
          {leaders.map((leader, index) => (
            <Col key={index} xs={12} sm={6} md={4} className="mb-4">
              <StyledCard>
                <Card.Img variant="top" src={`${IMAGE_BASE_URL}${leader.photo}`} alt={leader.position.position} crossorigin="anonymous"/>
                <Card.Body>
                  <Card.Title> {toTitleCase(leader.leaderMembership.first_name)}  {toTitleCase(leader.leaderMembership.last_name)}</Card.Title>
                  <Card.Text>{leader.position.position}</Card.Text>
                </Card.Body>
              </StyledCard>
            </Col>
          ))}
        </Row>
      </Container>
    </Section>
  );
};

export default LeadershipSection;
